import { render, staticRenderFns } from "./patient-fusion-modal.vue?vue&type=template&id=a257f1fc&scoped=true&"
import script from "./patient-fusion-modal.ts?vue&type=script&lang=ts&"
export * from "./patient-fusion-modal.ts?vue&type=script&lang=ts&"
import style0 from "./patient-fusion-modal.scss?vue&type=style&index=0&id=a257f1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a257f1fc",
  null
  
)

export default component.exports